import React, {useMemo} from "react";
import "./index.scss";
import {object, bool} from "prop-types";
import Title from "features/components/title";
import {__} from "services/i18n";
import {Icon} from "features/components/icon";
import Text from "features/components/text";

export const BestAnswer = (props) => {
    const {comment, archived} = props;

    const commentClean = useMemo(() => {
        if(!comment) return null;
        let c = comment.comment;
        comment.tags.forEach(tag => {
            c = c.replace("$TAG", `${tag.key}`);
        });
        return c;
    }, [comment]);

    if(!comment) return null;

    return <div className={`white-box best-answer ${archived ? "archived" : ""}`}>
        {!!archived && <Icon>diamond</Icon>}
        <Title size={20} align={"center"}>{__(`single-thread.best-answer.${archived ? "archived" : "temp"}`)}</Title>
        {!!comment.user.avatar ? <img src={comment.user.avatar} alt="author avatar"/> : <div className="default"><Icon>account-circle</Icon></div>}
        <Title size={16} align={"center"}>{comment.user.name}</Title>
        <Text size={12} align={"center"}>{__(`single-thread.best-answer.total-votes.${comment.votes.total === 1 ? "single" : "plural"}`, [{key: "[count]", value: comment.votes.total}])}</Text>
        <Text size={16} className={"comment"}>{commentClean}</Text>
    </div>
}
BestAnswer.propTypes = {
    comment: object.isRequired,
    archived: bool.isRequired
}